import { render } from "./AppContactItem.vue?vue&type=template&id=651b52d8&scoped=true&ts=true"
import script from "./AppContactItem.vue?vue&type=script&lang=ts"
export * from "./AppContactItem.vue?vue&type=script&lang=ts"

import "./AppContactItem.vue?vue&type=style&index=0&id=651b52d8&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651b52d8"]])

export default __exports__